import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, ShieldCheck, Users, TrendingUp, FileCheck } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Milk Quality Standards',
  description: 'Enforcing hygiene and quality standards across the dairy value chain.',
  icon: ShieldCheck
}, {
  title: 'Dairy Farmer Training',
  description: 'Building capacity in modern dairy farming and milk handling.',
  icon: Users
}, {
  title: 'Value Chain Development',
  description: 'Promoting investment in dairy processing and value addition.',
  icon: TrendingUp
}, {
  title: 'Licensing',
  description: 'Registering and licensing dairy equipment dealers and processors.',
  icon: FileCheck
}];
export function DdaPage() {
  return <>
      <Header data-id="element-731" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-732">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-733">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=1600&h=600&fit=crop")'
        }} data-id="element-734"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-735"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-736">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-737">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-738">
                <Home className="w-4 h-4 mr-1" data-id="element-739" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-740" />
              <span data-id="element-741">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-742" />
              <span className="text-white font-medium" data-id="element-743">DDA</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-744">DDA</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-745">
              Dairy Development Authority.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-746">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-747">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-748">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-749">
              To provide proper coordination and implementation of all policies
              designed to achieve and maintain self-sufficiency in the
              production of milk in Uganda by promoting production and
              competition in the dairy industry and monitoring the market for
              milk and dairy products.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-750">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-751">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-752">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-753">
                    <Icon className="w-6 h-6" data-id="element-754" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-755">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-756">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-757" />
    </>;
}